import React from 'react';
import styled from 'styled-components';

type MenuProps = {
    children: React.ReactNode;
};

const Style = styled.div`
    &&& {
        padding: 0 !important;
    }
`;

export function Menu({ children }: MenuProps) {
    return <Style className="menu">{children}</Style>;
}
